import EventBus from 'event_bus'

export function updateRegistrationTeasers (teaser) {
  if (teaser !== undefined && teaser !== '') {
    $('.js-dynamic-registration-teaser').html(teaser)
    $.each($('.js-registration-teaser'), function (index, value) {
      new RegistrationTeaser($(value), index)
    })
  }
}

export default class RegistrationTeaser {
  constructor ($el, index) {
    this.$el = $el
    this.$index = index
    this.$categories = $el.find('.js-registration-categories')
    this.$errorHint = $el.find('.js-registration-errorHint')
    this.$fader = $el.find('.js-registration-fader')
    this.$form = $el.find('.js-registration-form')
    this.$input = $el.find('.js-registration-input')
    this.$submit = $el.find('.js-registration-submit')
    this.addEventHandlers()
  }

  addEventHandlers () {
    this.$fader.click(this.onClick.bind(this))

    EventBus.on(`registration:submit${this.$index}`, this.onSubmit.bind(this))
    this.$submit.on('click', (event) => {
      event.preventDefault()
      EventBus.trigger(`registration:submit${this.$index}`, null)
    })
  }

  onClick () {
    $(this.$fader).toggle()
    $(this.$categories).addClass('registration-teaser__category-tags--expanded')
  }

  onSubmit () {
    $.ajax({
      method: 'POST',
      url: this.$form.attr('action'),
      data: this.$form.serialize(),
      dataType: 'json'
    }).success((response) => {
      if (response.show_snackbar === true) {
        EventBus.trigger('snackbar:message', {
          body: response.body,
          handlers: []
        })
        $(this.$input).val('')
      } else {
        $(this.$el).fadeOut()
        $(this.$el).replaceWith(response.body)
        $(this.$el).fadeIn()
      }
      EventBus.trigger('tracking:registrationSuccess', response.webtrekk)
    }).error(() => {
      $(this.$input).addClass('input--invalid')
      $(this.$errorHint).addClass('registration-teaser__error-hint--visible')
    })
  }
}
